import useSellerInfo from '@/modern/actions/useSellerInfo'

export default () => {
  const { sellerInfo } = useSellerInfo('weekSchedule')

  const buildConstants = () => {
    const scheduleConstants = []
    const monthConstants = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ]
    const weekConstants = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB']
    const weekFullNameConstants = [
      'Domingo',
      'Segunda-Feira',
      'Terça-Feira',
      'Quarta-Feira',
      'Quinta-Feira',
      'Sexta-Feira',
      'Sábado',
    ]

    for (let i = 0; i < 8; i += 1) {
      const schedule = { start: new Date(), end: new Date() }
      if (i === 0 || i === 7) {
        schedule.start.setHours(0, 0, 0, 0)
        schedule.end.setHours(0, 0, 0, 0)
        scheduleConstants.push(schedule)
      } else if (i === 6) {
        schedule.start.setHours(9, 0, 0, 0)
        schedule.end.setHours(12, 0, 0, 0)
        scheduleConstants.push(schedule)
      } else {
        schedule.start.setHours(9, 0, 0, 0)
        schedule.end.setHours(18, 0, 0, 0)
        scheduleConstants.push(schedule)
      }
    }

    return {
      monthConstants,
      weekConstants,
      scheduleConstants,
      weekFullNameConstants,
    }
  }

  const getJSONOfDays = () => {
    const now = new Date()
    const dateObjects = []
    const {
      monthConstants,
      weekConstants,
      weekFullNameConstants,
    } = buildConstants()

    for (let i = 0; i < 31; i += 1) {
      const nextDay = new Date(new Date().setDate(now.getDate() + i))
      const dateObject = {
        day: nextDay.getDate(),
        month: monthConstants[nextDay.getMonth()],
        dayOfWeek: weekConstants[nextDay.getDay()],
        dayOfWeekNumber: nextDay.getDay(),
        year: nextDay.getFullYear(),
        monthNumber: nextDay.getMonth(),
        fullNameDayOfTheWeek: weekFullNameConstants[nextDay.getDay()],
        isHoliday: false,
      }
      dateObjects.push(dateObject)
    }

    return dateObjects
  }

  const getArrayOfDates = (dayOfTheWeek, isHoliday) => {
    const arrayOfDates = []
    const { scheduleConstants } = buildConstants()
    const scheduleArray =
      (sellerInfo.length > 0 && sellerInfo) || scheduleConstants
    const { start, end } = isHoliday
      ? scheduleArray[7] || scheduleConstants[7]
      : scheduleArray[dayOfTheWeek] || scheduleConstants[dayOfTheWeek]

    if (end.getTime() < start.getTime()) end.setHours(23, 30, 0, 0)

    const gapBetweenTwoDates = Math.abs(start.getTime() - end.getTime())
    const howMany30Minutes = gapBetweenTwoDates / (1000 * 60 * 30)
    arrayOfDates.push(start)

    for (let i = 1; i < howMany30Minutes; i += 1) {
      const plus30Minutes = new Date()
      const pastDate = arrayOfDates[i - 1]
      plus30Minutes.setTime(pastDate.getTime() + 1000 * 60 * 30)
      arrayOfDates.push(plus30Minutes)
    }

    arrayOfDates.push(end)

    return arrayOfDates
  }

  const sellerIsWorkingOnDay = (dayOfWeek, isHoliday) => {
    const { scheduleConstants } = buildConstants()
    if (sellerInfo.length !== 0) {
      const scheduleOfDay = isHoliday
        ? sellerInfo[7] || scheduleConstants[7]
        : sellerInfo[dayOfWeek] || scheduleConstants[dayOfWeek]
      return scheduleOfDay.start.getHours() !== scheduleOfDay.end.getHours()
    }
    const scheduleOfDay = isHoliday
      ? scheduleConstants[7]
      : scheduleConstants[dayOfWeek]
    return scheduleOfDay.start.getHours() !== scheduleOfDay.end.getHours()
  }

  const sellerIsWorkingNow = isHoliday => {
    const now = new Date()
    const { scheduleConstants } = buildConstants()

    if (sellerInfo.length !== 0) {
      const scheduleOfDay = isHoliday
        ? sellerInfo[7] || scheduleConstants[7]
        : sellerInfo[now.getDay()] || scheduleConstants[now.getDay()]
      const isLate = now.getTime() > scheduleOfDay.end.getTime()
      const isNoon = now.getTime() < scheduleOfDay.start.getTime()
      return !isLate && !isNoon
    }

    const scheduleOfDay = isHoliday
      ? scheduleConstants[7]
      : scheduleConstants[now.getDay()]
    const isLate = now.getTime() > scheduleOfDay.end.getTime()
    const isNoon = now.getTime() < scheduleOfDay.start.getTime()

    return !isLate && !isNoon
  }

  const add30Minutes = oldDate => {
    return new Date(oldDate.getTime() + 1000 * 60 * 30)
  }

  const subtract30Minutes = oldDate => {
    return new Date(oldDate.getTime() - 1000 * 60 * 30)
  }

  const formatTime = (hours, minutes) => {
    const formattedHour = `0${hours}`.slice(-2)
    const formattedMinutes = `0${minutes}`.slice(-2)
    return { formattedHour, formattedMinutes }
  }

  const getRoundedNowDate = () => {
    const coeff = 1000 * 60 * 30
    const now = new Date()
    const date = new Date()
    date.setHours(now.getHours() + 2, now.getMinutes(), 0, 0)
    return new Date(Math.round(date.getTime() / coeff) * coeff)
  }

  const isToday = date => {
    const now = new Date()
    return (
      now.getDate() === date.day &&
      now.getMonth() === date.monthNumber &&
      now.getFullYear() === date.year
    )
  }

  const isAvaiable = date => {
    const now = new Date()
    const difference =
      Math.abs(now.getTime() - date.getTime()) / (1000 * 60 * 60)
    if (date.getTime() < now.getTime()) return false

    return difference >= 1.9833
  }

  return {
    getJSONOfDays,
    sellerIsWorkingOnDay,
    getArrayOfDates,
    add30Minutes,
    subtract30Minutes,
    formatTime,
    getRoundedNowDate,
    isToday,
    isAvaiable,
    sellerIsWorkingNow,
  }
}
